export function createPath(path: `/${string}`) {
    return `/my${path}`
}
